const Overlay = () => {
  return (
    <div
      className={`fixed top-0 left-0 right-0 bottom-0 z-20 
           bg-[#f3f3f4]/70`}
    ></div>
  );
};

export default Overlay;
